<ng-container *transloco="let t">

  <h2>{{ t('Worker Rankings') }} {{ t('for') }} {{month}}</h2>

  <ng-container *ngIf="!rankings"><img src="/assets/images/loading1.gif" title="Loading" ></ng-container>

  <div *ngIf="rankings">
    <c-row>
      <c-col class="col-12 col-lg-6" *ngIf="u.isMainCountry(okService.settings.country)">
        <h3><img src="https://flagcdn.com/w40/{{okService.settings.country.toLowerCase()}}.png" title=""> {{ t('Rankings for your Country') }}</h3>
        <c-card >
          <table
          [hover]="true"
          [responsive]="true"
          [striped]="true"
          align="middle"
          cTable
          class="mb-0 border"
          >
          <tbody>
            <tr *ngFor="let rank of rankings.country_rankings" [class.table-success]="!rank.company.includes('**')">
              <td>{{rank.place}}</td>
              <td><span [class.hide-name]="rank.company.includes('**')">{{rank.company}}</span></td>
            </tr>
          </tbody>
          </table>
        </c-card>
      </c-col>
      <c-col>
        <h3><img src="assets/images/world.png" alt="World">  {{ t('World Wide Ranking') }}</h3>
        <c-card>
          <div class="mb-4">
            <table
            [hover]="true"
            [responsive]="true"
            [striped]="true"
            align="middle"
            cTable
            class="mb-0 border"
            >
            <tbody>
              <tr *ngFor="let rank of rankings.world_rankings" [class.table-success]="!rank.company.includes('**')">
                <td>{{rank.place}}</td>
                <td><span [class.hide-name]="rank.company.includes('**')">{{rank.company}}</span></td>
                <td><img src="https://flagcdn.com/w40/{{rank.country.toLowerCase()}}.png" title="{{rank.country}}"></td>
              </tr>
            </tbody>
            </table>
          </div>
        </c-card>
      </c-col>
    </c-row>
  </div>

</ng-container>
